import { makeVar } from '@apollo/client';

// This is a reactive variable that stores the total number of current notifications
export const totalCurrentNotificationsVar = makeVar<number>(0);
